// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"0ea420c7","250":"d40dbbc6","453":"8b4b26dc","462":"696fb746","905":"906207f6"}[chunkId] + ".chunk.js";
};